import { useEffect } from 'react';

/**
 * Scrolls the page to the new hash when the URL hash changes.
 * If no hash is present in the URL, it scrolls to the element with the provided header ID.
 * @param headerId The ID of the header element to scroll to when no hash is present in the URL.
 */
export const useScrollHashIntoView = headerId => {
  const hash = window.location.hash.substring(1);
  useEffect(() => {
    const id = hash && hash !== '' ? hash : headerId;
    if (!id) {
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView();
    }
  }, [hash, headerId]);
};